module.exports = {
      id: "lifestyle-usage",
      viewBox: "0 0 24.217 32.155",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#lifestyle",
      toString: function () {
        return this.url;
      }
    }